import { Component, Inject } from '@angular/core';
import { CommonModule, NgSwitchCase } from '@angular/common';
import {
    IframeVideoPlayerComponent,
} from '../../../sale/components/step-display-video/iframe-video-player/iframe-video-player.component';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-video-dialog',
    standalone: true,
    imports: [CommonModule, IframeVideoPlayerComponent, NgSwitchCase, MatDialogActions, MatButtonModule, MatDialogClose],
    templateUrl: './video-dialog.component.html',
    styleUrl: './video-dialog.component.scss',
})
export class VideoDialogComponent {

    public constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            type: 'iframe',
            uri: string,
        },
    ) {
        //
    }
}
